/* eslint-disable react/no-danger */
import { Box, useTheme } from '@mui/material';
import ProvenExpertContext from '../../context/ProvenExpertContext';

export default function ProvenExpertGoogleStars() {
  const theme = useTheme();

  return (
    <ProvenExpertContext.Consumer>
      {(value) => (
        <Box
          sx={{
            '& *': {
              color: `${theme.palette.text.primary} !important`,
            },
            '& *::before': {
              color: `${theme.palette.text.primary} !important`,
            },
          }}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: value?.aggregateRating,
            }}
          />
        </Box>
      )}
    </ProvenExpertContext.Consumer>
  );
}
